export const seoKeywords = {
  name: 'keywords',
  content:
    'software development company, hire software developers, custom software development, software engineers to hire, blockchain development house, software house to hire, end-to-end software development, software development services',
};
